/** Responsibility: the Nodes panel data, refreshed often enough to be useful. */
import { useQuery } from '@tanstack/react-query';
import { hubApi } from '../client';

export function useNodes() {
  return useQuery({
    queryKey: ['nodes'],
    queryFn: hubApi.listNodes,
    // Heartbeats arrive on a cadence; this is the panel that tells the
    // operator the fleet is healthy before a drop, so it stays fresh.
    refetchInterval: 15_000,
  });
}
